import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import BrowserSpecific from 'Global/Shared/Components/browser-specific/browser-specific';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';
import Utils from 'Global/Shared/Components/Utils/Utils';
import WindowWidthChecker from 'Minetilbud/Shared/Components/WindowWidthChecker/WindowWidthChecker';

const log = debug('InspirationImage');
const debounce = new Debounce().debounce;

class InspirationImage extends BaseComponent {
	constructor(element) {
		super(element);

		this.resizeEvent = this.resizeHandler.bind(this);
		this.resizeHandler = debounce(this.resizeHandler, 250);
		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);
	
		this.initialize();
	}

	customLinkButton() {
		if (!this.dom.linkButton) return;

		const utils = new Utils();

		if (!utils.IsNullOrWhiteSpace(this.settings.buttonTextColor)) {
			this.dom.linkButton.style.color = this.settings.buttonTextColor;
		}

		if (!utils.IsNullOrWhiteSpace(this.settings.buttonBackgroundColor)) {
			this.dom.linkButton.style.backgroundColor = this.settings.buttonBackgroundColor;
		}
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
		window.addEventListener('resize', this.resizeEvent, false);
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		try {
			if (this.getSettings() === null) return;
			if (this.settings.desktopImage === '') throw 'no background image';
	
			this.initDomCache();
			this.customLinkButton();
			this.eventListeners();

			if (BrowserSpecific.isIE11()) {
				this.setup();
				return;
			}

			if (this.isInView() === false) return;

			this.setup()
		} catch(error) {
			log('initialize() - ERROR', error);
		}
	}

	/**
	 * @returns {boolean}
	 */
	isDeviceImage() {
		const windowWidthChecker = new WindowWidthChecker();
		return windowWidthChecker.GetState().isDevice && this.settings.deviceImage !== '';
	}

	isInView() {
		if (Sitecore.isEdit()) return true;

		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0 || elementRect.bottom > 0) && elementRect.top < window.innerHeight) {
			return true;
		};

		return false;
	}

	resizeHandler() {
		if (this.isInView() === false) return;
		this.setup();
	}

	scrollHandler() {
		if (this.isInView() === false) return;
		this.setup();
	}

	/**
	 * @param {string} imageSource
	 */
	setBackground(imageSource) {
		const imageElement = new Image();
		imageElement.onload = () => {
			log('image loaded', imageSource);
			this.setHeight(imageElement);
			this.dom.image.style.backgroundImage = `url(${imageSource})`;
		};
		imageElement.src = imageSource;
	}

	/**
	 * @param {Image} imageElement
	 * @param {number} imageElement.width
	 * @param {number} imageElement.height
	 */ 
	setHeight({ width, height}) {
		log('setHeight', width, height);
		let backgroundHeight = height;
		if (window.innerWidth < width) {
			log('innerWidth', window.innerWidth, window.innerWidth / width);
			backgroundHeight = height * (window.innerWidth / width);
		}
		this.dom.imageWrapper.style.height = `${backgroundHeight}px`;
	}

	setup() {
		if (this.imageVisible !== undefined) return;
		this.imageVisible =  true;

		let imageSource = this.settings.desktopImage;
		if (this.isDeviceImage()) {
			imageSource = this.settings.deviceImage;
			this.element.classList.remove('has-desktop-image');
		} else {
			this.element.classList.add('has-desktop-image');
		}

		this.setBackground(imageSource);
	}
}

export default InspirationImage;

